var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4150_18737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2674 8.68182H10.7326V12.5455H16.2209C15.7093 15 13.5698 16.4091 10.7326 16.4091C7.38372 16.4091 4.68605 13.7727 4.68605 10.5C4.68605 7.22727 7.38372 4.59091 10.7326 4.59091C12.1744 4.59091 13.4767 5.09091 14.5 5.90909L17.4767 3C15.6628 1.45455 13.3372 0.5 10.7326 0.5C5.05814 0.5 0.5 4.95455 0.5 10.5C0.5 16.0455 5.05814 20.5 10.7326 20.5C15.8488 20.5 20.5 16.8636 20.5 10.5C20.5 9.90909 20.407 9.27273 20.2674 8.68182Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4150_18737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.429688 16.409V4.59082L7.47729 10.4999L-0.429688 16.409Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4150_18737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2674 8.68182H10.7326V12.5455H16.2209C15.7093 15 13.5698 16.4091 10.7326 16.4091C7.38372 16.4091 4.68605 13.7727 4.68605 10.5C4.68605 7.22727 7.38372 4.59091 10.7326 4.59091C12.1744 4.59091 13.4767 5.09091 14.5 5.90909L17.4767 3C15.6628 1.45455 13.3372 0.5 10.7326 0.5C5.05814 0.5 0.5 4.95455 0.5 10.5C0.5 16.0455 5.05814 20.5 10.7326 20.5C15.8488 20.5 20.5 16.8636 20.5 10.5C20.5 9.90909 20.407 9.27273 20.2674 8.68182Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4150_18737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.429688 4.59082L7.47729 10.4999L10.7331 7.72718L21.8959 5.95446V-0.40918H-0.429688V4.59082Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4150_18737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2674 8.68182H10.7326V12.5455H16.2209C15.7093 15 13.5698 16.4091 10.7326 16.4091C7.38372 16.4091 4.68605 13.7727 4.68605 10.5C4.68605 7.22727 7.38372 4.59091 10.7326 4.59091C12.1744 4.59091 13.4767 5.09091 14.5 5.90909L17.4767 3C15.6628 1.45455 13.3372 0.5 10.7326 0.5C5.05814 0.5 0.5 4.95455 0.5 10.5C0.5 16.0455 5.05814 20.5 10.7326 20.5C15.8488 20.5 20.5 16.8636 20.5 10.5C20.5 9.90909 20.407 9.27273 20.2674 8.68182Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4150_18737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.429688 16.409L13.5238 5.95446L17.1982 6.409L21.8959 -0.40918V21.409H-0.429688V16.409Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4150_18737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2674 8.68182H10.7326V12.5455H16.2209C15.7093 15 13.5698 16.4091 10.7326 16.4091C7.38372 16.4091 4.68605 13.7727 4.68605 10.5C4.68605 7.22727 7.38372 4.59091 10.7326 4.59091C12.1744 4.59091 13.4767 5.09091 14.5 5.90909L17.4767 3C15.6628 1.45455 13.3372 0.5 10.7326 0.5C5.05814 0.5 0.5 4.95455 0.5 10.5C0.5 16.0455 5.05814 20.5 10.7326 20.5C15.8488 20.5 20.5 16.8636 20.5 10.5C20.5 9.90909 20.407 9.27273 20.2674 8.68182Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4150_18737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8943 21.409L7.4757 10.4999L5.61523 9.13627L21.8943 4.59082V21.409Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.70905658a0729fd9eef2679f66091458.svg";
export { ForwardRef as ReactComponent };